export function appendHiddenIFrame(url, id = 'auth_iframe') {
  const hiddenIFrame = window.document.createElement('iframe');

  hiddenIFrame.setAttribute('id', id);
  hiddenIFrame.setAttribute('width', '0');
  hiddenIFrame.setAttribute('height', '0');
  hiddenIFrame.style.display = 'none';

  window.document.body.appendChild(hiddenIFrame);
  // load page in the iframe
  hiddenIFrame.src = url;

  return hiddenIFrame;
}
